/* eslint-disable consistent-return */
window.Analytics = {
  trackEvent: (category, action, label, value, nonInteraction = false) => {
    dataLayer.push({
      event: 'GAtrackEvent',
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      eventValue: value,
      eventNonInteraction: nonInteraction,
    });
  },
  trackPageview: (url, title = document.title) => {
    dataLayer.push({
      event: 'GAtrackVirtualPageview',
      virtualPageviewUrl: url,
      virtualPageviewTitle: title,
    });
  },
  trackOnlyEvent: (event) => {
    dataLayer.push({
      event,
    });
  },
};

if (window.storedAnalyticsClientId) {
  const storeClientId = async (clientId) => {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    const response = await fetch('/analytics_client_id', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
      },
      body: JSON.stringify({
        _method: 'PUT',
        client_id: clientId,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  };

  const checkOrStoreClientId = () => {
    const tracker = ga.getAll()?.[0];

    if (!window.storedAnalyticsClientId && tracker) {
      const clientId = tracker.get('clientId');
      return storeClientId(clientId);
    }
  };

  const fireOnAnalyticsLoad = () => {
    if (typeof ga !== 'undefined' && ga.getAll) {
      return checkOrStoreClientId();
    }
    return window.setTimeout(fireOnAnalyticsLoad, 500);
  };

  fireOnAnalyticsLoad();
}
/* eslint-enable consistent-return */

class BootstrapDropdown {
  static toggleDropdownState(show, element) {
    const menuElement = element.querySelector('.dropdown-menu');

    if (show) {
      element.classList.add('show');
      if (menuElement) {
        menuElement.classList.add('show');
      }
    } else {
      element.classList.remove('show');
      if (menuElement) {
        menuElement.classList.remove('show');
      }
    }
  }

  static closeAllDropdowns() {
    const dropdownMenus = document.querySelectorAll('.dropdown-menu');
    dropdownMenus.forEach(menu => menu.classList.remove('show'));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const dropdowns = document.querySelectorAll('.dropdown');
  const dropdownToggles = document.querySelectorAll('.dropdown-toggle');

  dropdownToggles.forEach((toggle) => {
    toggle.addEventListener('click', (event) => {
      if (toggle.getAttribute('href') === '#') {
        event.preventDefault();
      }
    });
  });

  const onMouseEnter = function () {
    BootstrapDropdown.toggleDropdownState(true, this);
  };

  const onMouseLeave = function () {
    BootstrapDropdown.toggleDropdownState(false, this);
  };

  const checkWidth = () => {
    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener('mouseenter', onMouseEnter);
      dropdown.addEventListener('mouseleave', onMouseLeave);
    });

    if (!window.matchMedia('(min-width: 768px)').matches) {
      // Disable subnavigation dropdowns on mobile devices
      const nawbarDropdowns = document.querySelectorAll('.sub-navbar .dropdown');

      nawbarDropdowns.forEach((dropdown) => {
        dropdown.removeEventListener('mouseenter', onMouseEnter);
        dropdown.removeEventListener('mouseleave', onMouseLeave);
      });
    }
  };

  window.addEventListener('load', checkWidth);
  window.addEventListener('resize', checkWidth);
});
